import Helper from '@lovata/popup-helper';

export default new class BuyDrawer {
  constructor() {
    // Init selectors
    this.panelSelector = 'buy__panel';
    this.panelOpenSelector = 'buy__panel_visible';
    this.drawerBtnSelector = 'js-buy-drawer';
    this.drawerParentSelector = 'wrapper';
    this.drawerDisableSelector = 'buy_empty';
    this.drawerCloseSelector = 'buy-drawer-panel__close';
    this.drawerContentSelector = 'buy-drawer-info';

    this.buyPartialSelector = 'common/buy/buy-drawer-ajax';

    this.preLoaderSelector = 'buy-drawer-panel__preloader';

    this.idSelector = 'data-offer-id';
    // Add events
    this.handler();
  }

  handler() {
    $(document).on('click', `.${this.drawerBtnSelector}`, ({ currentTarget }) => {
      const isDisable = $(currentTarget).hasClass(this.drawerDisableSelector);

      if (isDisable) return;

      const panel = $(currentTarget).parents(`.${this.drawerParentSelector}`).find(`.${this.panelSelector}`);
      const focusTarget = !panel.hasClass(this.drawerOpenBtnSelector)
        ? document.querySelector(`.${this.drawerCloseSelector}`)
        : document.querySelector(`.${this.drawerOpenBtnSelector}`);
      const isOpen = panel.hasClass(this.panelOpenSelector);

      const offerID = currentTarget.getAttribute(this.idSelector);

      Helper.changeNoScrollSelector('_allow-scroll');
      Helper.setBodyScrollState(isOpen);
      Helper.overlayHandler(!isOpen, focusTarget, panel[0]);

      panel.toggleClass(this.panelOpenSelector);

      const contentSelector = panel.find(`.${this.drawerContentSelector}`);
      contentSelector.html('');

      setTimeout(() => {
        Helper.focusTrapManager(!isOpen, panel[0]);
      }, 300);

      this.clearBuyDrawer(isOpen);

      if (!isOpen) {
        this.loadOffer(offerID);
      }
    });
  }

  clearBuyDrawer(isOpen) {
    if (!isOpen) return;

    const buyContent = document.querySelector(`.${this.drawerContentSelector}`);
    buyContent.innerHtml = '';

    /*
    $(`.${this.searchInputSelector}`).val('');

    const searchResultWrapper = $(`.${this.searchResultWrapper}`);

    const childrenNode = searchResultWrapper.children();

    if (!childrenNode.length) return;

    childrenNode.remove();
    */
  }

  loadOffer(offerID) {
    if (!offerID) return;
    const that = this;

    oc.ajax('Buy::onOffer', {
      data: {
        offer_id: offerID,
      },
      success: function (response) { // eslint-disable-line object-shorthand, func-names
        that.updateOfferData(response.results);
      },
      loading: `.${this.preLoaderSelector}`,
    });
  }

  updateOfferData(data) {
    $(`.${this.panelSelector}`).find(`.${this.drawerContentSelector}`).html(data);
  }
}();
